// export const BASE_URL = `https://lban-portal-8hsd.onrender.com`;
export const BASE_URL = `https://paa-webapp.azurewebsites.net`;
// export const BASE_URL = `http://localhost:8000`;
